module.exports = __webpack_public_path__ + "img/eye-1132531_640.87d7497f.jpg";